var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.motivationList),function(item){return _c('div',{key:item.id},[_c('p',{staticClass:"nd_p_text14 mb-4"},[_vm._v(_vm._s(item[`name_${_vm.$i18n.locale}`]))]),_c('p',{staticClass:"nd_p_text16 nd_font_weight500"},[_vm._v("© "+_vm._s(item.authorName))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }